import { render } from "./PrivacyBox.vue?vue&type=template&id=3dc1d468&scoped=true"
import script from "./PrivacyBox.vue?vue&type=script&lang=js"
export * from "./PrivacyBox.vue?vue&type=script&lang=js"

import "./PrivacyBox.vue?vue&type=style&index=0&id=3dc1d468&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc1d468"]])

export default __exports__